export default "__VITE_ASSET__738c051f__"